/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { withMyTheme } from "../theme/theme";
import { Typography, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { mobileCss } from "../util/isMobile";

const PageContainerStyle = withMyTheme((theme) => css`
  min-height: 100vh;
  padding: 5rem 2rem;
  background-color: ${theme.palette.background.default};
  
  ${mobileCss(`
    padding: 3rem 1rem;
  `)}
`);

const TitleStyle = withMyTheme((theme) => css`
  font-family: 'Great Vibes', serif;
  font-size: 3rem;
  color: ${theme.palette.primary.main};
  text-align: center;
  margin-bottom: 2rem;
  
  ${mobileCss(`
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  `)}
`);

const ContentStyle = withMyTheme((theme) => css`
  font-family: 'Cormorant', serif;
  font-size: 1.2rem;
  color: ${theme.palette.text.primary};
  line-height: 1.8;
  margin-bottom: 2rem;
  
  h2 {
    font-family: 'Cormorant', serif;
    font-size: 1.8rem;
    color: ${theme.palette.primary.main};
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  
  p {
    margin-bottom: 1.5rem;
  }
  
  ${mobileCss(`
    font-size: 1.1rem;
    line-height: 1.6;
  `)}
`);

const BackButtonStyle = withMyTheme((theme) => css`
  margin-bottom: 2rem;
  color: ${theme.palette.primary.main};
  
  &:hover {
    background-color: rgba(212, 163, 115, 0.1);
  }
`);

export const Agreement = () => {
  const navigate = useNavigate();
  
  return (
    <div css={PageContainerStyle}>
      <Container maxWidth="md">
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate('/')} 
          css={BackButtonStyle}
        >
          Powrót do strony głównej
        </Button>
        
        <Typography variant="h1" css={TitleStyle}>
          Warunki Umowy
        </Typography>
        
        <div css={ContentStyle}>
          <h2>1. Przedmiot umowy</h2>
          <p>
            Przedmiotem umowy jest wykonanie i utrzymanie strony internetowej ślubnej dla Klienta, zgodnie z wybranym pakietem oraz indywidualnymi ustaleniami.
          </p>
          
          <h2>2. Zakres usług</h2>
          <p>
            W ramach wybranego pakietu świadczymy następujące usługi:
          </p>
          <ul>
            <li>Zaprojektowanie i wykonanie strony internetowej</li>
            <li>Dostosowanie kolorystyki i stylu do preferencji Klienta</li>
            <li>Umieszczenie treści dostarczonych przez Klienta</li>
            <li>Publikacja strony pod wybranym adresem</li>
            <li>Utrzymanie strony przez określony w pakiecie okres</li>
          </ul>
          
          <h2>3. Czas realizacji</h2>
          <p>
            Standardowy czas realizacji strony internetowej wynosi 48 godzin od momentu dostarczenia przez Klienta wszystkich niezbędnych materiałów i informacji.
          </p>
          
          <h2>4. Wynagrodzenie i płatności</h2>
          <p>
            Wynagrodzenie za wykonanie strony internetowej jest zgodne z cennikiem dostępnym na stronie lub indywidualnymi ustaleniami. Płatność powinna zostać dokonana zgodnie z poniższymi zasadami:
          </p>
          <ul>
            <li>50% kwoty jako zaliczka przed rozpoczęciem prac</li>
            <li>50% kwoty po akceptacji projektu, przed publikacją strony</li>
          </ul>
          
          <h2>5. Prawa autorskie</h2>
          <p>
            Po dokonaniu pełnej płatności Klient otrzymuje niewyłączną licencję na korzystanie ze strony internetowej. Wszelkie prawa autorskie do kodu źródłowego, projektu graficznego i innych elementów strony pozostają własnością Weddie Site.
          </p>
          
          <h2>6. Odpowiedzialność za treści</h2>
          <p>
            Klient ponosi pełną odpowiedzialność za treści i materiały dostarczone do umieszczenia na stronie internetowej. Weddie Site zastrzega sobie prawo do odmowy publikacji treści naruszających prawo lub zasady współżycia społecznego.
          </p>
          
          <h2>7. Gwarancja i wsparcie techniczne</h2>
          <p>
            Udzielamy gwarancji na prawidłowe działanie strony internetowej przez okres określony w wybranym pakiecie. W ramach gwarancji zapewniamy bezpłatne usunięcie błędów wynikających z winy Wykonawcy.
          </p>
          
          <h2>8. Ochrona danych osobowych</h2>
          <p>
            Przetwarzanie danych osobowych odbywa się zgodnie z obowiązującymi przepisami prawa oraz Polityką Prywatności dostępną na stronie internetowej.
          </p>
          
          <h2>9. Rozwiązanie umowy</h2>
          <p>
            Każda ze stron może rozwiązać umowę z zachowaniem 14-dniowego okresu wypowiedzenia. W przypadku rozwiązania umowy przez Klienta zaliczka nie podlega zwrotowi.
          </p>
          
          <h2>10. Postanowienia końcowe</h2>
          <p>
            W sprawach nieuregulowanych niniejszą umową mają zastosowanie przepisy Kodeksu Cywilnego. Wszelkie spory wynikające z realizacji umowy będą rozstrzygane przez sąd właściwy dla siedziby Weddie Site.
          </p>
        </div>
      </Container>
    </div>
  );
};
